// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_ionic_core_components_p-Cz5nLPGT_js":"19048cd154729b60","node_modules_ionic_core_components_p-BgwEQWW6_js":"d01e5d286f66d0b0","node_modules_ionic_core_components_p-CneGxKsZ_js":"8cbb2811511cde4d","node_modules_ionic_core_components_p-CEmXdzGo_js":"573463336a967a51"}[chunkId] + ".js";
};